import React, { useEffect, useState } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import VistaPreviaDocumentoSoportePDF from "./VistaPreviaDocumentoSoportePDF";
import axios from '../../axios/axiosconf';

function InformacionDocumentoSoporte() {
    const { id } = useParams();
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [documento, setDocumento] = useState(null);
    const [loading, setLoading] = useState(true);
    const [proveedores, setProveedores] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [cuentasPorPagar, setCuentasPorPagar] = useState([]);
    const [egresos, setEgresos] = useState([]);
    const [respuestaDian, setRespuestaDian] = useState(null);
    const [permisos, setPermisos] = useState([]);
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);
    const [creador, setCreador] = useState(null);

    // Modal Abono
    const [showModalAbono, setShowModalAbono] = useState(false);
    const [valorAbono, setValorAbono] = useState('');
    const [observacionesAbono, setObservacionesAbono] = useState('');

    // Modal Anulación
    const [showModalAnulacion, setShowModalAnulacion] = useState(false);
    const [prefijoAnulacion, setPrefijoAnulacion] = useState('');
    const [motivoAnulacion, setMotivoAnulacion] = useState('');
    const [fechaAnulacion, setFechaAnulacion] = useState(new Date().toISOString().split('T')[0]);
    const [prefijosNota, setPrefijosNota] = useState([]);

    // Modal Debug
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState('');

    // Modal Vista Previa Egreso
    const [showModalEgreso, setShowModalEgreso] = useState(false);
    const [egresoSeleccionado, setEgresoSeleccionado] = useState(null);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS
        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_documentos_soporte');

        if (!tienePermiso) {
            setHasPermission(false);
            return;
        }

        setHasPermission(true);
        setPermisos(userdata.up || []);

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar proveedores
        axios.get('/proveedores?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setProveedores(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar usuarios
        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar documento específico
        if (id) {
            axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                .then(response => {
                    if (response.status === 200) {
                        setDocumento(response.data);
                        // Cargar cuentas por pagar
                        cargarCuentasPorPagar();
                        // Cargar egresos asociados
                        cargarEgresos(id);
                        // Cargar respuesta DIAN si está enviado
                        if (response.data.estado === 1) {
                            cargarRespuestaDian(id);
                        }

                        // 🆕 Cargar encabezado personalizado del usuario que creó el documento
                        if (response.data.users_id) {
                            axios.get(`/encabezado-personalizado?uid=${response.data.users_id}`)
                                .then(encResponse => {
                                    if (encResponse.status === 200 && encResponse.data && encResponse.data.estado === 1) {
                                        setEncabezadoPersonalizado(encResponse.data);
                                        console.log('Encabezado personalizado cargado:', encResponse.data);
                                    }
                                })
                                .catch(error => {
                                    console.log('No hay encabezado personalizado habilitado:', error);
                                    setEncabezadoPersonalizado(null);
                                });

                            // 🆕 Cargar información del usuario que creó el documento (creador)
                            const usuarioEncontrado = usuarios.find(u => u.id == response.data.users_id);
                            if (usuarioEncontrado) {
                                setCreador(usuarioEncontrado);
                                console.log('Creador cargado:', usuarioEncontrado);
                            }
                        }
                    }
                })
                .catch(error => {
                    console.log('Error cargando documento: ' + error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [id]);

    const cargarCuentasPorPagar = () => {
        axios.get('/cuentas-por-pagar')
            .then(response => {
                if (response.status === 200) {
                    setCuentasPorPagar(response.data);
                }
            })
            .catch(error => {
                console.log('Error al cargar cuentas por pagar: ' + error);
            });
    };

    const cargarEgresos = (documentoId) => {
        axios.get(`/egresos-documento-soporte/${documentoId}`)
            .then(response => {
                if (response.status === 200) {
                    setEgresos(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando egresos: ' + error);
            });
    };

    const cargarRespuestaDian = (documentoId) => {
        axios.get(`/documento-soporte/${documentoId}/respuesta-dian`)
            .then(response => {
                if (response.data.success) {
                    setRespuestaDian(response.data.data);
                }
            })
            .catch(error => {
                console.log('No hay respuesta DIAN para este documento');
            });
    };

    const getNombreProveedor = (proveedorId) => {
        const proveedor = proveedores.find(p => p.id === proveedorId);
        return proveedor ? proveedor.nombre_proveedor : 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id === usuarioId);
        return usuario ? usuario.name : 'N/A';
    };

    const getSaldoPendiente = () => {
        if (!documento) return 0;
        const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === documento.id);
        return cuenta ? parseFloat(cuenta.valor_pendiente || 0) : 0;
    };

    const getTipoPagoTexto = (tipoPago) => {
        switch(tipoPago) {
            case 'pagada': return 'Pagada';
            case 'por_pagar': return 'Por Pagar';
            default: return 'Pagada';
        }
    };

    const getTipoPagoColor = (tipoPago) => {
        switch(tipoPago) {
            case 'pagada': return 'badge badge-outline-success';
            case 'por_pagar': return 'badge badge-outline-warning';
            default: return 'badge badge-success';
        }
    };

    const getEstadoTexto = (estado) => {
        switch(estado) {
            case 0: return 'Generado';
            case 1: return 'Enviado DIAN';
            case 2: return 'Anulado';
            case 3: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch(estado) {
            case 0: return 'badge badge-outline-secondary';
            case 1: return 'badge badge-outline-success';
            case 2: return 'badge badge-outline-danger';
            case 3: return 'badge badge-outline-danger';
            default: return 'badge badge-outline-secondary';
        }
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const date = new Date(fecha);
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const abrirModalAbono = () => {
        const saldoPendiente = getSaldoPendiente();
        
        if (saldoPendiente <= 0) {
            alert('Este documento no tiene saldo pendiente por pagar.');
            return;
        }

        setValorAbono('');
        setObservacionesAbono('');
        setShowModalAbono(true);
    };

    const realizarAbono = async () => {
        if (!valorAbono || parseFloat(valorAbono) <= 0) {
            alert('Por favor ingrese un valor válido para el abono.');
            return;
        }

        const saldoPendiente = getSaldoPendiente();
        const montoAbono = parseFloat(valorAbono);

        if (montoAbono > saldoPendiente) {
            alert(`El abono no puede ser mayor al saldo pendiente ($${saldoPendiente.toLocaleString('es-CO')})`);
            return;
        }

        if (!window.confirm(`¿Está seguro de realizar un abono de $${montoAbono.toLocaleString('es-CO')}?`)) {
            return;
        }

        try {
            const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === documento.id);
            
            if (!cuenta) {
                alert('No se encontró la cuenta por pagar para este documento.');
                return;
            }

            const response = await axios.post(`/cuenta-por-pagar/${cuenta.id}/abono`, {
                valor_abono: montoAbono,
                observaciones: observacionesAbono
            });
            
            if (response.status === 200 || response.status === 201) {
                const mensaje = response.data.estado === 'Pagada' 
                    ? `Abono de $${montoAbono.toLocaleString('es-CO')} realizado exitosamente.\nDocumento COMPLETAMENTE PAGADO.\nEgreso N° ${response.data.numero_egreso} generado.`
                    : `Abono de $${montoAbono.toLocaleString('es-CO')} realizado exitosamente.\nSaldo pendiente: $${response.data.saldo_pendiente.toLocaleString('es-CO')}\nEgreso N° ${response.data.numero_egreso} generado.`;
                
                alert(mensaje);
                setShowModalAbono(false);
                // Recargar datos
                cargarCuentasPorPagar();
                cargarEgresos(id);
                // Recargar documento
                let userdata = JSON.parse(localStorage.getItem('userdata'));
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setDocumento(response.data);
                        }
                    });
            }
        } catch (error) {
            console.error('Error al realizar abono:', error);
            alert('Error al realizar abono: ' + (error.response?.data?.message || error.message));
        }
    };

    const generarEgresoCompleto = async () => {
        if (!window.confirm('¿Está seguro de generar un egreso para cancelar esta cuenta por pagar?')) {
            return;
        }

        try {
            const response = await axios.post('/documento-soporte/generar-egreso', {
                documento_soporte_id: documento.id
            });
            
            if (response.status === 200 || response.status === 201) {
                alert(`Egreso N° ${response.data.numero_egreso} generado exitosamente.\nDocumento marcado como PAGADA.`);
                // Recargar datos
                cargarCuentasPorPagar();
                cargarEgresos(id);
                let userdata = JSON.parse(localStorage.getItem('userdata'));
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setDocumento(response.data);
                        }
                    });
            }
        } catch (error) {
            console.error('Error al generar egreso:', error);
            alert('Error al generar egreso: ' + (error.response?.data?.message || error.message));
        }
    };

    const abrirModalAnulacion = async () => {
        // Si es borrador (estado 0), anular directamente sin modal
        if (documento.estado === 0) {
            if (!window.confirm('¿Está seguro de anular este documento soporte en borrador?')) {
                return;
            }
            
            try {
                const response = await axios.post('/nota-documento-soporte', {
                    documento_soporte_id: documento.id
                });
                
                if (response.status === 200 || response.status === 201) {
                    alert('Documento soporte anulado exitosamente (borrador)');
                    history.push('/listado-documentos-soporte');
                }
            } catch (error) {
                alert('Error al anular el documento: ' + (error.response?.data?.message || error.message));
            }
            return;
        }
        
        // Si está enviado a DIAN (estado 1), cargar prefijos y mostrar modal
        if (documento.estado === 1) {
            let userdata = JSON.parse(localStorage.getItem('userdata'));

            try {
                const response = await axios.get('/parametros-fev?uid=' + userdata.user_id);
                if (response.status === 200) {
                    const prefijosFiltrados = response.data.filter(p => 
                        p.tipo === 'Nota Documento Soporte' && 
                        p.estado == 1
                    );
                    setPrefijosNota(prefijosFiltrados);
                    setShowModalAnulacion(true);
                }
            } catch (error) {
                alert('Error al cargar prefijos: ' + error.message);
            }
        } else {
            alert('Solo se pueden anular documentos en estado Borrador o Enviado a DIAN');
        }
    };

    const generarNotaAnulacion = async () => {
        if (!prefijoAnulacion) {
            alert('Por favor seleccione un prefijo');
            return;
        }

        if (!fechaAnulacion) {
            alert('Por favor seleccione una fecha');
            return;
        }

        if (!window.confirm('¿Está seguro de generar una Nota de Documento Soporte para anular? Esta acción no se puede deshacer.')) {
            return;
        }

        try {
            const envioResponse = await axios.post('/nota-documento-soporte/enviar-dian-directo', {
                documento_soporte_id: documento.id,
                parametrosfev_id: parseInt(prefijoAnulacion),
                motivo_observacion: motivoAnulacion || 'Anulación de documento soporte',
                fecha_emision: fechaAnulacion
            });
            
            setShowModalAnulacion(false);
            
            if (envioResponse.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Nota de documento soporte enviada exitosamente a la DIAN',
                    cufe: envioResponse.data.uuid
                });
                setShowModalDebug(true);
                // Recargar documento
                let userdata = JSON.parse(localStorage.getItem('userdata'));
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setDocumento(response.data);
                        }
                    });
            } else {
                setDebugType('error');
                setDebugData({
                    message: envioResponse.data.message,
                    response: envioResponse.data.response,
                    json_enviado: envioResponse.data.json_enviado,
                    status_code: envioResponse.data.status_code
                });
                setShowModalDebug(true);
            }
            
        } catch (error) {
            console.error('Error al enviar nota a DIAN:', error);
            setShowModalAnulacion(false);
            
            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data
            });
            setShowModalDebug(true);
        }
    };

    const anulacionProvisional = async () => {
        if (!window.confirm('¿Está seguro de anular provisionalmente este documento?\n\nEsta acción cambiará el estado a ANULADO sin enviar nada a la DIAN.')) {
            return;
        }

        try {
            const response = await axios.post(`/documento-soporte/${documento.id}/anulacion-provisional`, {});
            
            if (response.status === 200) {
                alert('Documento anulado provisionalmente');
                history.push('/listado-documentos-soporte');
            }
        } catch (error) {
            console.error('Error al anular:', error);
            alert('Error al anular el documento: ' + (error.response?.data?.message || error.message));
        }
    };

    const enviarDian = async () => {
        if (!window.confirm('¿Está seguro de enviar este documento a la DIAN?')) {
            return;
        }

        try {
            const response = await axios.post(`/documento-soporte/${documento.id}/enviar-dian`, {});
            
            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Documento soporte enviado exitosamente a la DIAN',
                    cufe: response.data.uuid,
                    estado: response.data.estado
                });
                setShowModalDebug(true);
                // Recargar documento
                let userdata = JSON.parse(localStorage.getItem('userdata'));
                axios.get(`/documento-soporte/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setDocumento(response.data);
                        }
                    });
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            console.error('Error al enviar a DIAN:', error);
            
            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data
            });
            setShowModalDebug(true);
        }
    };

    // Función para abrir modal de vista previa de egreso
    const abrirModalEgreso = (egreso) => {
        setEgresoSeleccionado(egreso);
        setShowModalEgreso(true);
    };

    // Función para imprimir egreso - abre vista previa
    const imprimirEgreso = () => {
        if (!egresoSeleccionado) return;
        // Abrir vista previa en nueva ventana
        // El usuario puede usar Ctrl+P o el botón de imprimir de la página
        window.open(`/smile/#/vista-previa-egreso/${egresoSeleccionado.id}`, '_blank');
    };

    // 🆕 Función para generar PDF editable del documento soporte
    const generarPDFEditable = async () => {
        try {
            // Crear contenedor temporal
            const contenedorTemporal = document.createElement('div');
            contenedorTemporal.style.position = 'absolute';
            contenedorTemporal.style.left = '-9999px';
            contenedorTemporal.style.top = '0';
            document.body.appendChild(contenedorTemporal);
            
            // Obtener proveedor
            const proveedor = proveedores.find(p => p.id === documento.proveedor_id);
            
            // Renderizar componente PDF
            ReactDOM.render(
                <VistaPreviaDocumentoSoportePDF
                    documento={documento}
                    client={client}
                    proveedor={proveedor}
                    encabezadoPersonalizado={encabezadoPersonalizado}
                    creador={creador}
                />,
                contenedorTemporal
            );
            
            // Esperar a que se renderice
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Generar PDF
            const html2pdf = await import('html2pdf-fix-jspdf');
            const element = document.getElementById('documento-soporte-pdf-editable');
            
            const opt = {
                margin: 10,
                filename: `documento-soporte-${documento.prefijo}-${documento.numero}.pdf`,
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    letterRendering: true
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                    compress: true
                },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                }
            };
            
            // Generar y guardar el PDF directamente
            await html2pdf.default().from(element).set(opt).save();
            
            // Limpiar
            document.body.removeChild(contenedorTemporal);
            
        } catch (error) {
            console.error('Error generando PDF:', error);
            alert('Error al generar el PDF. Por favor, intente nuevamente.');
        }
    };

    // 🆕 Función para imprimir PDF editable del documento soporte
    const imprimirPDFEditable = async () => {
        try {
            // Crear contenedor temporal
            const contenedorTemporal = document.createElement('div');
            contenedorTemporal.style.position = 'absolute';
            contenedorTemporal.style.left = '-9999px';
            contenedorTemporal.style.top = '0';
            document.body.appendChild(contenedorTemporal);
            
            // Obtener proveedor
            const proveedor = proveedores.find(p => p.id === documento.proveedor_id);
            
            // Renderizar componente PDF
            ReactDOM.render(
                <VistaPreviaDocumentoSoportePDF
                    documento={documento}
                    client={client}
                    proveedor={proveedor}
                    encabezadoPersonalizado={encabezadoPersonalizado}
                    creador={creador}
                />,
                contenedorTemporal
            );
            
            // Esperar a que se renderice
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Generar PDF y abrir ventana de impresión
            const html2pdf = await import('html2pdf-fix-jspdf');
            const element = document.getElementById('documento-soporte-pdf-editable');
            
            const opt = {
                margin: 10,
                filename: `documento-soporte-${documento.prefijo}-${documento.numero}.pdf`,
                image: { type: 'jpeg', quality: 0.95 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    logging: false,
                    letterRendering: true
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'letter',
                    orientation: 'portrait',
                    compress: true
                },
                pagebreak: {
                    mode: ['avoid-all', 'css', 'legacy']
                }
            };
            
            // Generar PDF como blob para imprimir
            const pdf = await html2pdf.default().from(element).set(opt).outputPdf('blob');
            const pdfBlob = new Blob([pdf], { type: 'application/pdf' });
            const url = URL.createObjectURL(pdfBlob);
            
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
            
            iframe.onload = () => {
                // Esperar 500ms antes de abrir el diálogo de impresión
                setTimeout(() => {
                    iframe.contentWindow.print();
                }, 500);
                
                // Limpiar después de 60 segundos
                setTimeout(() => {
                    if (document.body.contains(iframe)) {
                        document.body.removeChild(iframe);
                        URL.revokeObjectURL(url);
                    }
                }, 60000);
            };
            
            // Limpiar contenedor temporal
            document.body.removeChild(contenedorTemporal);
            
        } catch (error) {
            console.error('Error imprimiendo PDF:', error);
            alert('Error al imprimir el PDF. Por favor, intente nuevamente.');
        }
    };

    // 🔒 PROTECCIÓN DE RUTA
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loading) {
        return <Loading />;
    }

    if (!documento) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <h1 className="m-0">Documento no encontrado</h1>
                        </div>
                    </div>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    const saldoPendiente = getSaldoPendiente();

    return (
        <div className="hold-transition">
            <style>{`
                .badge-outline {
                    background-color: transparent;
                    border-width: 1px;
                    border-style: solid;
                }
                .badge-outline-secondary {
                    color: #6c757d;
                    border: 1px solid #6c757d;
                    background-color: transparent;
                }
                .badge-outline-success {
                    color: #28a745;
                    border: 1px solid #28a745;
                    background-color: transparent;
                }
                .badge-outline-danger {
                    color: #dc3545;
                    border: 1px solid #dc3545;
                    background-color: transparent;
                }
                .badge-outline-warning {
                    color: #ffc107;
                    border: 1px solid #ffc107;
                    background-color: transparent;
                }
                .card-info.card-outline {
                    border-top: 3px solid #17a2b8;
                }
                .table th {
                    background-color: #282828;
                    color: #f6fcfd;
                    border-top: none;
                    font-weight: 600;
                    font-size: 0.9rem;
                }
                .table td {
                    vertical-align: middle;
                    font-size: 0.9rem;
                }
            `}</style>
            <Header client={client} />
            <Aside client={client} activelink="billing" />
            
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                    <li className="breadcrumb-item"><Link to="/listado-documentos-soporte">Documentos Soporte</Link></li>
                                    <li className="breadcrumb-item active">Información</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-8">
                                <h1 className="m-0">Documento Soporte N° {documento.prefijo}-{documento.numero}</h1>
                            </div>
                            <div className="col-sm-4">
                                <Link to="/listado-documentos-soporte" className="btn btn-secondary float-right">
                                    <i className="fas fa-arrow-left"></i> Volver al Listado
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        {/* Card de Información General */}
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-info-circle mr-2"></i>Información General</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-6">
                                        <table className="table table-sm table-borderless">
                                            <tbody>
                                                <tr>
                                                    <td style={{width: '40%'}}><strong>N° Documento:</strong></td>
                                                    <td>{documento.prefijo}-{documento.numero}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Fecha Emisión:</strong></td>
                                                    <td>{formatearFecha(documento.fecha_emision)}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Proveedor:</strong></td>
                                                    <td>{getNombreProveedor(documento.proveedor_id)}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Usuario:</strong></td>
                                                    <td>{getNombreUsuario(documento.users_id)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-md-6">
                                        <table className="table table-sm table-borderless">
                                            <tbody>
                                                <tr>
                                                    <td style={{width: '40%'}}><strong>Estado DIAN:</strong></td>
                                                    <td>
                                                        <span className={`badge ${getEstadoColor(documento.estado)}`}>
                                                            {getEstadoTexto(documento.estado)}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Estado Pago:</strong></td>
                                                    <td>
                                                        <span className={getTipoPagoColor(documento.tipo_pago || 'pagada')}>
                                                            {getTipoPagoTexto(documento.tipo_pago || 'pagada')}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Valor Total:</strong></td>
                                                    <td className="text-success font-weight-bold">
                                                        ${Math.round(parseFloat(documento.valor_total)).toLocaleString('es-CO')}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Saldo Pendiente:</strong></td>
                                                    <td className={saldoPendiente > 0 ? 'text-danger font-weight-bold' : 'text-success font-weight-bold'}>
                                                        ${Math.round(saldoPendiente).toLocaleString('es-CO')}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {documento.uuid && (
                                    <div className="row mt-3">
                                        <div className="col-12">
                                            <div className="alert alert-info">
                                                <strong>CUFE:</strong> <code>{documento.uuid}</code>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Card de Acciones */}
                        <div className="card card-info card-outline">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-cogs mr-2"></i>Acciones</h3>
                            </div>
                            <div className="card-body">
                                <div className="btn-toolbar" role="toolbar">
                                    {/* Botón Vista Previa - Siempre visible */}
                                    <div className="btn-group mr-2 mb-2" role="group">
                                        <button 
                                            className="btn btn-info"
                                            onClick={() => window.open(`/#/vista-previa-documento-soporte/${documento.id}`, '_blank')}
                                            title="Vista Previa e Impresión"
                                        >
                                            <i className="fas fa-eye"></i> Vista Previa
                                        </button>
                                    </div>

                                    {/* Botones según estado y tipo de pago */}
                                    {documento.tipo_pago === 'por_pagar' && saldoPendiente > 0 && (
                                        <>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-primary"
                                                    onClick={abrirModalAbono}
                                                    title="Realizar Abono Parcial"
                                                >
                                                    <i className="fas fa-coins"></i> Realizar Abono
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-primary"
                                                    onClick={generarEgresoCompleto}
                                                    title="Pagar Saldo Completo"
                                                >
                                                    <i className="fas fa-money-bill-wave"></i> Pagar Todo
                                                </button>
                                            </div>
                                        </>
                                    )}

                                    {/* Estado 0: Generado */}
                                    {documento.estado === 0 && (
                                        <>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={abrirModalAnulacion}
                                                    title="Anular Documento"
                                                >
                                                    <i className="fas fa-ban"></i> Anular
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={anulacionProvisional}
                                                    title="Anulación Provisional (sin DIAN)"
                                                >
                                                    <i className="fas fa-exclamation-triangle"></i> Anulación Provisional
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-primary"
                                                    onClick={enviarDian}
                                                    title="Enviar a la DIAN"
                                                >
                                                    <i className="fas fa-paper-plane"></i> Enviar a DIAN
                                                </button>
                                            </div>
                                        </>
                                    )}
                                    
                                    {/* Estado 1: Enviado DIAN */}
                                    {documento.estado === 1 && (
                                        <>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={abrirModalAnulacion}
                                                    title="Generar Nota de Anulación"
                                                >
                                                    <i className="fas fa-file-invoice"></i> Nota Anulación
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={anulacionProvisional}
                                                    title="Anulación Provisional (sin DIAN)"
                                                >
                                                    <i className="fas fa-exclamation-triangle"></i> Anulación Provisional
                                                </button>
                                            </div>
                                        </>
                                    )}
                                    
                                    {/* Estado 3: Error DIAN */}
                                    {documento.estado === 3 && (
                                        <>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={abrirModalAnulacion}
                                                    title="Anular Documento"
                                                >
                                                    <i className="fas fa-ban"></i> Anular
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={anulacionProvisional}
                                                    title="Anulación Provisional (sin DIAN)"
                                                >
                                                    <i className="fas fa-exclamation-triangle"></i> Anulación Provisional
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-primary"
                                                    onClick={enviarDian}
                                                    title="Reintentar envío a la DIAN"
                                                >
                                                    <i className="fas fa-redo"></i> Enviar a DIAN
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* 🆕 Vista Previa del Documento Soporte */}
                        <div className="card card-info card-outline" id="vista-previa-documento-container">
                            <div className="card-header no-print" style={{ backgroundColor: '#f6fcfd', borderBottom: '2px solid #17a2b8' }}>
                                <h3 className="card-title" style={{ color: '#282828' }}>
                                    <i className="fas fa-file-invoice" style={{ color: '#17a2b8' }}></i> Vista Previa del Documento
                                </h3>
                                <div className="card-tools">
                                    <button
                                        className="btn btn-sm btn-primary mr-1"
                                        onClick={imprimirPDFEditable}
                                        title="Imprimir documento en formato PDF"
                                    >
                                        <i className="fas fa-print mr-1"></i> Imprimir
                                    </button>
                                    <button
                                        className="btn btn-sm btn-danger"
                                        onClick={generarPDFEditable}
                                        title="Descargar documento en formato PDF"
                                    >
                                        <i className="fas fa-file-pdf mr-1"></i> PDF
                                    </button>
                                </div>
                            </div>
                            <div className="card-body" id="vista-previa-documento-content">
                                <VistaPreviaDocumentoSoportePDF
                                    documento={documento}
                                    client={client}
                                    proveedor={proveedores.find(p => p.id === documento?.proveedor_id)}
                                    encabezadoPersonalizado={encabezadoPersonalizado}
                                    creador={creador}
                                />
                            </div>
                        </div>

                        {/* Card de Egresos Asociados */}
                        {egresos.length > 0 && (
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h3 className="card-title"><i className="fas fa-money-bill-wave mr-2"></i>Egresos Asociados</h3>
                                </div>
                                <div className="card-body p-0">
                                    <table className="table table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>N° Egreso</th>
                                                <th>Fecha</th>
                                                <th>Valor</th>
                                                <th>Estado</th>
                                                <th>Observaciones</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {egresos.map(egreso => (
                                                <tr key={egreso.id}>
                                                    <td><strong>{egreso.numero || 'N/A'}</strong></td>
                                                    <td>{formatearFecha(egreso.fecha_creacion)}</td>
                                                    <td className="text-right font-weight-bold">
                                                        ${Math.round(parseFloat(egreso.valor_total || 0)).toLocaleString('es-CO')}
                                                    </td>
                                                    <td>
                                                        {egreso.estado === 0 ? (
                                                            <span className="badge badge-success">Activo</span>
                                                        ) : egreso.estado === 1 ? (
                                                            <span className="badge badge-danger">Anulado</span>
                                                        ) : (
                                                            <span className="badge badge-secondary">Desconocido</span>
                                                        )}
                                                    </td>
                                                    <td>{egreso.observaciones || '-'}</td>
                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-sm btn-info"
                                                            onClick={() => abrirModalEgreso(egreso)}
                                                            title="Ver Egreso"
                                                        >
                                                            <i className="fas fa-eye"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Card de Respuesta DIAN */}
                        {respuestaDian && (
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h3 className="card-title"><i className="fas fa-server mr-2"></i>Respuesta DIAN</h3>
                                </div>
                                <div className="card-body">
                                    <pre style={{
                                        backgroundColor: '#f8f9fa',
                                        padding: '15px',
                                        borderRadius: '4px',
                                        maxHeight: '400px',
                                        overflow: 'auto',
                                        fontSize: '12px'
                                    }}>
                                        {JSON.stringify(respuestaDian, null, 2)}
                                    </pre>
                                </div>
                            </div>
                        )}

                    </div>
                </section>
            </div>

            {/* Modal Abono */}
            {showModalAbono && (
                <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header bg-light">
                                <h4 className="modal-title">
                                    <i className="fas fa-coins mr-2"></i>Realizar Abono
                                </h4>
                                <button type="button" className="close" onClick={() => setShowModalAbono(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-info">
                                    <i className="fas fa-info-circle"></i> Puede realizar abonos parciales desde $1 hasta el saldo pendiente.
                                </div>
                                
                                <div className="form-group">
                                    <label>Documento</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={`${documento.prefijo}-${documento.numero}`}
                                        readOnly
                                    />
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Valor Total</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={`$${Math.round(parseFloat(documento.valor_total)).toLocaleString('es-CO')}`}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Saldo Pendiente</label>
                                            <input 
                                                type="text" 
                                                className="form-control text-warning font-weight-bold" 
                                                value={`$${Math.round(saldoPendiente).toLocaleString('es-CO')}`}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label>Valor del Abono *</label>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text">$</span>
                                        </div>
                                        <input 
                                            type="number" 
                                            className="form-control" 
                                            placeholder="Ingrese el valor del abono"
                                            value={valorAbono}
                                            onChange={(e) => setValorAbono(e.target.value)}
                                            min="1"
                                            max={saldoPendiente}
                                            step="0.01"
                                            required
                                        />
                                    </div>
                                    <small className="form-text text-muted">
                                        Mínimo: $1 - Máximo: ${Math.round(saldoPendiente).toLocaleString('es-CO')}
                                    </small>
                                </div>
                                
                                <div className="form-group">
                                    <label>Observaciones</label>
                                    <textarea 
                                        className="form-control" 
                                        rows="3"
                                        value={observacionesAbono}
                                        onChange={(e) => setObservacionesAbono(e.target.value)}
                                        placeholder="Observaciones del abono (opcional)..."
                                    ></textarea>
                                </div>

                                {valorAbono && parseFloat(valorAbono) > 0 && (
                                    <div className="alert alert-success">
                                        <strong>Resumen del Abono:</strong><br/>
                                        • Valor a abonar: <strong>${parseFloat(valorAbono).toLocaleString('es-CO')}</strong><br/>
                                        • Saldo después del abono: <strong>${(saldoPendiente - parseFloat(valorAbono)).toLocaleString('es-CO')}</strong><br/>
                                        • Se generará: <strong>Egreso automático</strong>
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalAbono(false)}>
                                    Cancelar
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-info" 
                                    onClick={realizarAbono}
                                    disabled={!valorAbono || parseFloat(valorAbono) <= 0}
                                >
                                    <i className="fas fa-coins"></i> Realizar Abono
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Anulación */}
            {showModalAnulacion && (
                <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header bg-danger text-white">
                                <h4 className="modal-title">Anular Documento Soporte</h4>
                                <button type="button" className="close text-white" onClick={() => setShowModalAnulacion(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-warning">
                                    <i className="fas fa-exclamation-triangle"></i> Esta acción generará una Nota de Documento Soporte y anulará el documento original.
                                </div>
                                
                                <div className="form-group">
                                    <label>Documento a Anular</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        value={`${documento.prefijo}${documento.numero}`}
                                        readOnly
                                    />
                                </div>
                                
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Prefijo Nota *</label>
                                            <select 
                                                className="form-control" 
                                                value={prefijoAnulacion}
                                                onChange={(e) => setPrefijoAnulacion(e.target.value)}
                                                required
                                            >
                                                <option value="">Seleccionar...</option>
                                                {prefijosNota.map(p => (
                                                    <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>N° Nota</label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                value={prefijosNota.find(p => p.id == prefijoAnulacion)?.numero_factura || ''}
                                                readOnly
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>Fecha Anulación *</label>
                                            <input 
                                                type="date" 
                                                className="form-control" 
                                                value={fechaAnulacion}
                                                onChange={(e) => setFechaAnulacion(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <label>Motivo de Anulación</label>
                                    <textarea 
                                        className="form-control" 
                                        rows="3"
                                        value={motivoAnulacion}
                                        onChange={(e) => setMotivoAnulacion(e.target.value)}
                                        placeholder="Ingrese el motivo de la anulación..."
                                    ></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalAnulacion(false)}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={generarNotaAnulacion}>
                                    <i className="fas fa-ban"></i> Generar Nota y Anular
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Vista Previa Egreso */}
            {showModalEgreso && egresoSeleccionado && (
                <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className="modal-header bg-light">
                                <h4 className="modal-title">
                                    <i className="fas fa-money-bill-wave mr-2"></i>Egreso N° {egresoSeleccionado.numero}
                                </h4>
                                <button type="button" className="close" onClick={() => setShowModalEgreso(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <table className="table table-sm table-borderless">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{width: '40%'}}><strong>N° Egreso:</strong></td>
                                                            <td>{egresoSeleccionado.numero}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Fecha:</strong></td>
                                                            <td>{formatearFecha(egresoSeleccionado.fecha_creacion)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Método de Pago:</strong></td>
                                                            <td>{egresoSeleccionado.metodo_pago || 'N/A'}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-md-6">
                                                <table className="table table-sm table-borderless">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{width: '40%'}}><strong>Estado:</strong></td>
                                                            <td>
                                                                {egresoSeleccionado.estado === 0 ? (
                                                                    <span className="badge badge-success">Activo</span>
                                                                ) : (
                                                                    <span className="badge badge-danger">Anulado</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Valor Total:</strong></td>
                                                            <td className="text-success font-weight-bold">
                                                                ${Math.round(parseFloat(egresoSeleccionado.valor_total || 0)).toLocaleString('es-CO')}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Usuario:</strong></td>
                                                            <td>{getNombreUsuario(egresoSeleccionado.users_id)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {egresoSeleccionado.observaciones && (
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="alert alert-info">
                                                        <strong>Observaciones:</strong><br/>
                                                        {egresoSeleccionado.observaciones}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="alert alert-secondary">
                                                    <i className="fas fa-info-circle"></i> Para ver el documento completo con todos los detalles, use el botón "Imprimir" o "PDF".
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalEgreso(false)}>
                                    Cerrar
                                </button>
                                <button type="button" className="btn btn-primary" onClick={imprimirEgreso}>
                                    <i className="fas fa-print"></i> Imprimir
                                </button>
                                <button type="button" className="btn btn-danger" onClick={imprimirEgreso}>
                                    <i className="fas fa-file-pdf"></i> PDF
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Debug */}
            {showModalDebug && (
                <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                    <div className="modal-dialog modal-xl modal-dialog-scrollable">
                        <div className="modal-content">
                            <div className={`modal-header ${debugType === 'success' ? 'bg-info' : 'bg-danger'} text-white`}>
                                <h4 className="modal-title">
                                    {debugType === 'success' ? (
                                        <><i className="fas fa-check-circle mr-2"></i>Envío Exitoso</>
                                    ) : (
                                        <><i className="fas fa-exclamation-triangle mr-2"></i>Error en el Envío</>
                                    )}
                                </h4>
                                <button type="button" className="close text-white" onClick={() => setShowModalDebug(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {debugType === 'success' ? (
                                    <div>
                                        <div className="alert alert-info">
                                            <h5><i className="fas fa-check-circle"></i> {debugData?.message}</h5>
                                        </div>
                                        <div className="card border-info">
                                            <div className="card-header bg-info text-white">
                                                <strong><i className="fas fa-info-circle mr-2"></i>Detalles de la Respuesta</strong>
                                            </div>
                                            <div className="card-body">
                                                <p><strong>CUFE:</strong> <code style={{fontSize: '0.9em'}}>{debugData?.cufe}</code></p>
                                                <p><strong>Estado del Documento:</strong> 
                                                    <span className="badge badge-success ml-2">Enviado a DIAN</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <div className="alert alert-danger">
                                            <h5><i className="fas fa-exclamation-triangle"></i> {debugData?.message}</h5>
                                        </div>
                                        
                                        {debugData?.response && (
                                            <div className="card mb-3">
                                                <div className="card-header bg-warning">
                                                    <strong><i className="fas fa-exclamation-triangle mr-2"></i>Respuesta de la DIAN</strong>
                                                </div>
                                                <div className="card-body">
                                                    <pre style={{
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '15px',
                                                        borderRadius: '4px',
                                                        maxHeight: '400px',
                                                        overflow: 'auto',
                                                        fontSize: '12px',
                                                        whiteSpace: 'pre-wrap',
                                                        wordWrap: 'break-word'
                                                    }}>{JSON.stringify(debugData.response, null, 2)}</pre>
                                                </div>
                                            </div>
                                        )}
                                        
                                        {debugData?.json_enviado && (
                                            <div className="card mb-3">
                                                <div className="card-header bg-primary text-white">
                                                    <strong><i className="fas fa-code mr-2"></i>JSON Enviado a la DIAN</strong>
                                                </div>
                                                <div className="card-body">
                                                    <pre style={{
                                                        backgroundColor: '#f8f9fa',
                                                        padding: '15px',
                                                        borderRadius: '4px',
                                                        maxHeight: '400px',
                                                        overflow: 'auto',
                                                        fontSize: '12px',
                                                        whiteSpace: 'pre-wrap',
                                                        wordWrap: 'break-word'
                                                    }}>{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default InformacionDocumentoSoporte;
